import ContentEditorExitWrapper from '../navigation/ContentEditorExitWrapper';

// Re-export for backwards compatibility
export default ContentEditorExitWrapper;